import { defineStore } from "pinia";
import { readonly } from "vue";
import { getMessaging, getToken } from "firebase/messaging";
import { initializeApp } from "firebase/app";

export const useNotificationStore = defineStore("notification-store", {
  state: () => ({
    // yeah yeah I need this out today
    developmentFirebaseConfig: readonly({
      apiKey: "AIzaSyBbh9h3SH2Iz0aPd8YCK_HPnENLVquOMVk",
      authDomain: "test-devlovin.firebaseapp.com",
      projectId: "test-devlovin",
      storageBucket: "test-devlovin.firebasestorage.app",
      messagingSenderId: "733997323427",
      appId: "1:733997323427:web:1489487cf437dd55789b16",
    }),
    productionFirebaseConfig: readonly({
      apiKey: "AIzaSyAhjSog_EbcGjcbQclahFHf2PVu5t25Dxo",
      authDomain: "test-bloglovin.firebaseapp.com",
      projectId: "test-bloglovin",
      storageBucket: "test-bloglovin.firebasestorage.app",
      messagingSenderId: "751874736847",
      appId: "1:751874736847:web:44a56016834d8426faadba",
    }),
    developmentVapidKey: "BIG3-bqMrKtkASNa7cQV72QsTG_ynmMHmqsEf_jBHMM2mFKv_czcdQSaFVtrw2953zh7m3fmErt9XlLy6ZyZIPM",
    productionVapidKey: "BEv5BPeE_OIDZwwTRpPjJqFE4fDAZGfnjLOs3zeZMjLJ1sPL_ZC0d8DCTURQmF7bSl100QVmssRlztJu8VzoWJo",
    firebaseApp: null,
    messaging: null,
  }),
  getters: {
  },
  actions: {
    saveToken(token) {
      this.apiPost("/notification/device/subscribe", { device_token: token }, () => {});
    },
    async requestPermission() {
      if (!("serviceWorker" in navigator)) {
        // console.warn("Service workers are not available on this browser");
        return;
      }

      if (this.firebaseApp === null) {
        let firebaseConfig = this.productionFirebaseConfig;
        if (process.env.NODE_ENV === "development") {
          firebaseConfig = this.developmentFirebaseConfig;
        }

        this.firebaseApp = initializeApp(firebaseConfig);
        this.messaging = getMessaging(this.firebaseApp);
      }

      if (Notification.permission === "granted") {
        return;
      }

      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        let vapidKey = this.productionVapidKey;
        if (process.env.NODE_ENV === "development") {
          vapidKey = this.developmentVapidKey;
        }

        let scriptUrl = "/firebase-messaging-prod-sw.js";
        if (process.env.NODE_ENV === "development") {
          scriptUrl = "/firebase-messaging-dev-sw.js";
        }

        const registration = await navigator.serviceWorker.register(scriptUrl);

        const currentToken = await getToken(this.messaging, {
          vapidKey: vapidKey,
          serviceWorkerRegistration: registration,
        });

        if (currentToken) {
          this.saveToken(currentToken);
        } else {
          throw new Error("did not get token after permission granted");
        }
      }
      // else {
      //   console.warn("Notification permission not granted.");
      // }
    },
  },
});
